import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2, XCircle } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { launchCashfree } from "@/lib/cashfreeCheckout";

export default function PaymentCashfree() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [error, setError] = useState("");
  const [purpose, setPurpose] = useState("cart");

  useEffect(() => {
    if (!sessionId) {
      setError("Missing checkout session");
      return;
    }
    let cancelled = false;
    const start = async () => {
      try {
        const { data } = await api.get(`/payments/launch/${sessionId}`);
        if (cancelled) return;
        if (data.purpose === "seller_plan") setPurpose("seller_plan");
        if (data.purpose === "ai_credits") setPurpose("ai_credits");
        if (data.payment_status === "paid") {
          window.location.replace(`/payment/success?session_id=${encodeURIComponent(sessionId)}`);
          return;
        }
        if (cancelled) return;
        await launchCashfree(data);
      } catch (e) {
        if (!cancelled) setError(apiError(e) || "Could not open Cashfree checkout");
      }
    };
    start();
    return () => { cancelled = true; };
  }, [sessionId]);

  return (
    <div className="max-w-lg mx-auto px-6 pt-40 pb-24 text-center" data-testid="payment-cashfree-page">
      {error ? (
        <>
          <XCircle className="w-14 h-14 mx-auto text-aura-muted mb-6" />
          <h1 className="font-serif text-3xl font-bold mb-3">Checkout did not start</h1>
          <p className="text-aura-muted mb-8">{error}</p>
          <Link to={purpose === "seller_plan" ? "/seller/subscribe" : purpose === "ai_credits" ? "/tryon" : "/cart"} className="px-7 py-3 btn-accent rounded-full text-sm font-semibold">
            {purpose === "seller_plan" ? "Back to plans" : purpose === "ai_credits" ? "Back to try-on" : "Back to bag"}
          </Link>
        </>
      ) : (
        <>
          <Loader2 className="w-10 h-10 mx-auto text-aura-cyan animate-spin mb-6" />
          <h1 className="font-serif text-3xl font-bold mb-2">Opening Cashfree…</h1>
          <p className="text-aura-muted">UPI, cards, and netbanking.</p>
        </>
      )}
    </div>
  );
}
